import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../styles/hero-slider.css";
import { MdArrowRightAlt } from "react-icons/md";

import heroImage1 from "../images/Car-Images/merc.png";
import heroImage2 from "../images/Car-Images/volvo.png";

const HeroSlider = () => {
  const [progress, setProgress] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const sliderRef = useRef(null);
  const servicesRef = useRef(null);

  /* ---------------- PRELOAD HERO IMAGES ---------------- */

  useEffect(() => {
    const images = [heroImage1, heroImage2];
    let loaded = 0;

    images.forEach((src) => {
      const img = new Image();
      img.src = src;

      img.onload = () => {
        loaded++;

        if (loaded === images.length) {
          setTimeout(() => {
            setIsLoading(false);
          }, 250);
        }
      };

      img.onerror = () => {
        loaded++;

        if (loaded === images.length) {
          setIsLoading(false);
        }
      };
    });
  }, []);

  /* ---------------- SLIDER SETTINGS ---------------- */

  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
    pauseOnHover: false,

    beforeChange: (_, next) => {
      setCurrentSlide(next);
      setProgress(0);
    },

    afterChange: () => {
      triggerReveal();
    },
  };

  /* ---------------- PROGRESS BAR ---------------- */

  useEffect(() => {
    setProgress(0);

    const duration = 10000;
    const stepTime = 50;
    const increment = (stepTime / duration) * 100;

    const interval = setInterval(() => {
      setProgress((prev) => (prev < 100 ? prev + increment : 100));
    }, stepTime);

    return () => clearInterval(interval);
  }, [currentSlide]);

  /* ---------------- TEXT REVEAL ---------------- */

  const triggerReveal = () => {
    if (!sliderRef.current) return;

    const allSlides =
      sliderRef.current.innerSlider.list.querySelectorAll(
        ".slick-slide [data-reveal]"
      );

    allSlides.forEach((el) => {
      el.classList.remove("revealed");
    });

    const activeSlide =
      sliderRef.current.innerSlider.list.querySelector(".slick-active");

    if (!activeSlide) return;

    const revealElements = activeSlide.querySelectorAll("[data-reveal]");

    revealElements.forEach((el) => {
      void el.offsetWidth;
      el.classList.add("revealed");
    });
  };

  useEffect(() => {
    triggerReveal();
  }, []);

  return (
    <div
      className="hero__slider-section dark-background"
      ref={servicesRef}
    >
   

      <div className={`hero__loading ${!isLoading ? "hide" : ""}`}>
        <div className="loading-box title"></div>

        <div className="loading-box text"></div>

        <div className="loading-box text short"></div>

        <div className="loading-buttons">
          <div className="loading-btn"></div>

          <div className="loading-btn outline"></div>
        </div>
      </div>

   

      <Slider
        ref={sliderRef}
        {...settings}
        className={`hero__slider ${!isLoading ? "loaded" : ""}`}
      >
     

        <div className="slider__item slider__item-01">
          <div className="slider__content">
            <p className="hero__subtitle" data-reveal="left">
              Kenya’s Home of Best Car Deals
            </p>

            <p className="hero__content" data-reveal="right">
              Discover a wide range of{" "}
              <strong>affordable cars for sale in Kenya</strong>,
              from reliable sedans to powerful SUVs.
              We are here to help you find the perfect match with trusted quality.
            </p>

            <div className="hero__buttons">
              <button className="reserve__btn" data-reveal>
                <a href="/vehicles">
                  Explore
                  <MdArrowRightAlt className="explore-icon" />
                </a>
              </button>

              <button className="call__us-btn" data-reveal>
                <a href="/contact-us">
                  Call Us
                  <MdArrowRightAlt className="explore-icon" />
                </a>
              </button>
            </div>
          </div>
        </div>

       

        <div className="slider__item slider__item-03">
          <div className="slider__content">
            <p className="hero__subtitle" data-reveal="left">
              Flexible Plans, Easy Ownership
            </p>

            <p className="hero__content" data-reveal="right">
              Getting your dream car has never been easier.
              We accept <strong>car financing in Kenya</strong> through
              leading banks and financial institutions.
              Choose flexible payment plans that suit your lifestyle.
            </p>

            <div className="hero__buttons">
              <button className="reserve__btn" data-reveal>
                <a href="/vehicles">
                  Explore
                  <MdArrowRightAlt className="explore-icon" />
                </a>
              </button>

              <button className="call__us-btn" data-reveal>
                <a href="/contact-us">
                  Call Us
                  <MdArrowRightAlt className="explore-icon" />
                </a>
              </button>
            </div>
          </div>
        </div>
      </Slider>

    

      <div className="progress__wrapper">
        {[0, 1].map((idx) => (
          <div
            key={idx}
            className="progress__bar"
            onClick={() => sliderRef.current?.slickGoTo(idx)}
          >
            <div
              className={`progress__fill ${
                idx === currentSlide ? "active" : ""
              }`}
              style={{
                width: idx === currentSlide ? `${progress}%` : "0%",
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default HeroSlider;